<template>
    <div class="bg-white p-5 pb-1 mb-3 rounded">
        <h2 class="ranking-title mb-3">Catálogo de cursos</h2>

        <div class="row mt-1">
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <label for="cursos_categorias"><b>Categorias</b></label>
                <select class="form-control rounded-8 sin-borde" v-model="categoria" id="">
                    <option value="">Seleccione una categoría</option>
                    <optgroup v-for="(cat, index) of catalogo.categorias.children" :key="index" :label="cat.name">
                        <option v-for="(catc, i) of cat.children" :key="'child' + i" :value="catc.term_id">
                            {{ catc.name }}
                        </option>
                    </optgroup>
                </select>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <label for="cursos_tipo"><b>Tipo</b></label>
                <select class="form-control rounded-8 sin-borde" v-model="tipo_cursos" id="">
                    <option value="default">Cursos Utel</option>
                    <option value="propios">Cursos Propios</option>
                </select>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 pt-4 d-flex justify-content-end input-search-catalog-courses">
                <search-input-component :search="search" @onSearch="onFilterSearch($event)"></search-input-component>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                <button class="btn bg-utel text-white sin-borde rounded-8 mx-1 mt-4" @click.prevent="filterDataCourse">Filtrar cursos</button>
            </div>
        </div>
        <div class="row">

        </div>

        <div class="row" id="sel_cursos">
            <h4 class="mt-4"><strong>Seleccionar cursos</strong></h4>
        </div>

        <div class="row my-2" v-show="!loadingTable">
            <div v-for="curso in catalogo.cursos" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                <div class="card h-100 rounded-8">
                    <img class="card-img-top course-img" :src="curso.image" alt="Card image cap">
                    <div class="card-body p-3 pb-2">
                        <div class="mb-3">
                            <span class="badge badge-secondary text-primary bg-utel-v2-secondary">Curso</span>
                        </div>
                        <div class="text-card-normal mb-3">
                            <h5 class="card-title" style="height: 57px;">{{ curso.name }}</h5>
                            <p class="card-text course-description short-description-diploma">{{ strippedContent(curso.content) }}</p>
                        </div>
                        <div class="text-center d-flex justify-content-center">
                            <button type="button" class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                            alt="ver" title="ver" @click.prevent="watchInfoRoute(curso)">
                                <i class="fa-solid fa-eye"></i>
                            </button>
                            <button class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8 mx-1 my-sm-2 pt-2"
                                @click.prevent="addCourseItems(curso)">Agregar a ruta</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex justify-content-center" v-if="mostrarPaginasCourses"
                style="margin-bottom: 10px; margin-top: 30px">
                <div class="d-flex align-middle" v-if="paginaActualCourses - 2 > 0">
                    <button class="" @click.prevent="getCoursesByPage(1)"><i
                            class="fa-solid fa-angles-left"></i></button>
                </div>
                <div class="d-flex align-middle" style="margin-left: 10px" v-if="paginaActualCourses > 1">
                    <button class="" @click.prevent="getCoursesByPage(paginaActualCourses - 1)"><i
                            class="fa-solid fa-angle-left"></i></button>
                </div>
                <div class="d-flex align-middle" style="margin-left: 10px">
                    <button class="btn bg-utel-v2-secondary sin-borde text-primary rounded-8" @click.prevent="getCoursesByPage(paginaActualCourses)">{{
                        paginaActualCourses }}</button>
                </div>
                <div class="d-flex align-middle" style="margin-left: 10px"
                    v-if="ultimaPaginaCourses == -1 || paginaActualCourses < ultimaPaginaCourses">
                    <button class="" @click.prevent="getCoursesByPage(paginaActualCourses + 1)"><i
                            class="fa-solid fa-angle-right"></i></button>
                </div>
                <div class="d-flex align-middle" style="margin-left: 10px"
                    v-if="ultimaPaginaCourses != -1 && ultimaPaginaCourses >= paginaActualCourses + 2">
                    <button class="" @click.prevent="getCoursesByPage(ultimaPaginaCourses)"><i
                            class="fa-solid fa-angles-right"></i></button>
                </div>
            </div>
        </div>

        <loading-component v-show="loadingTable"></loading-component>

        <modalinfocourse v-if="showModalInfoCourse" :course="watchCourse" @close="closeModalInfoCourse"></modalinfocourse>

        <modaladdtoroute v-if="showModalAddToRoute" :course="watchCourse" :url_routes_by_company="url_routes_by_company" @close="closeModalAddToRoute"></modaladdtoroute>

    </div>
</template>
<script>
import modalinfocourse from './ModalInfoCourse.vue';
import modaladdtoroute from './ModalAddToRoute.vue';
export default {
    props: ['url_courses_wp', 'url_routes_by_company'],
    components:{
        modalinfocourse,
        modaladdtoroute
    },
    data(){
        return {
            tipo_cursos: 'default',
            categoria: '',
            searchCurso: '',
            catalogo: {
                categorias: [],
                cursos: [],
            },
            search: '',
            loadingTable: true,
            mostrarPaginasCourses: false,
            paginaActualCourses: 0,
            ultimaPaginaCourses: -1,
            showModalInfoCourse: false,
            showModalAddToRoute: false,
            watchCourse:{id:'', content: '', name: '', duration: '', sections: [], count_students: 0}
        }
    },
    mounted(){
        this.getDataCourse();
        this.getWordpressCourseCategory();
    },
    computed:{

    },
    methods:{
        getDataCourse() {
            this.loadingTable = true;
            axios.get(this.url_courses_wp).then((res) => {
                this.catalogo.cursos = res.data;
                if (res.data.length > 0) {
                    this.mostrarPaginasCourses = true;
                    this.paginaActualCourses = 1;
                }
                this.loadingTable = false;
            });
        },
        getWordpressCourseCategory() {
            axios.get("/search/category").then((res) => {
                this.catalogo.categorias = res.data;

                let arrayParent = [];
                let categoriesParent = this.catalogo.categorias.children;
                for (var k in categoriesParent) {
                    if (categoriesParent.hasOwnProperty(k)) {
                        arrayParent.push(k);
                    }
                }
                this.parentsCategories = arrayParent;
            });
        },
        onFilterSearch(searchText) {
            this.search = searchText;
        },
        getCoursesByPage(page) {
            document.getElementById('sel_cursos').scrollIntoView();
            this.loadingTable = true;
            axios.get(this.url_courses_wp, {
                params: {
                    search: this.search,
                    category: this.categoria,
                    courseType: this.tipo_cursos,
                    uuidClient: this.uuidclient,
                    page: page
                },
            }).then((res) => {
                this.catalogo.cursos = res.data;
                if (res.data.length > 0) {
                    this.mostrarPaginasCourses = true;
                    this.paginaActualCourses = page;
                }
                if (res.data.length < 10) {
                    this.ultimaPaginaCourses = page;
                }
                this.loadingTable = false;
            });
        },
        filterDataCourse() {
            this.loadingTable = true;
            axios
                .get(this.url_courses_wp, {
                    params: {
                        search: this.search,
                        category: this.categoria,
                        courseType: this.tipo_cursos,
                        uuidClient: this.uuidclient,
                    },
                })
                .then((res) => {
                    this.catalogo.cursos = res.data;
                    this.ultimaPaginaCourses = -1;
                    if (res.data.length > 0) {
                        this.mostrarPaginasCourses = true;
                        this.paginaActualCourses = 1;
                    }
                    if (res.data.length < 10) {
                        this.ultimaPaginaCourses = 1;
                    }
                    this.loadingTable = false;
                });
        },
        strippedContent(text) {
            let regex = /(<([^>]+)>)/ig;
            return text.replace(regex, "");
        },
        watchInfoRoute(course){
            this.watchCourse = course;
            this.showModalInfoCourse = true;
        },
        closeModalInfoCourse(){
            this.showModalInfoCourse = false;
        },
        closeModalAddToRoute(){
            this.showModalAddToRoute = false;
        },
        addCourseItems(item){
            console.log(item);
            this.watchCourse = item;
            this.showModalAddToRoute = true;
        }
    }
}
</script>
<style>
.input-search-catalog-courses.searchcontainer{
    margin-top: 1rem !important;
}

@media(min-width: 768px ){
    .course-img{
        height: 250px;
        object-fit: cover;
    }
}

.course-description{
    height: auto !important;
}
</style>
